/**
 * Community panel
 *
 * A summarised view of a community management screen that is accessible from community cards, list and search items
 *
 * Displays:
 * -Community information
 * -Owners
 * -Tools
 */

/**
 * React
 */
import * as React from 'react';


import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Icon } from '@fluentui/react/lib/Icon';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react/lib/Callout';

/**
 * Child components
 */
import CommunityTools from '../CommunityToolsComponent';
import Owners from '../CommunityOwnersComponent';
import Tag from '../../FormFields/Tag';

const CommunityPanelComponent = (props: any) => {
  const {
    community,
    allMembers,
    profile,
    brandName,
    constants,
    onPanelDismiss,
    inviteMembersActionCreators,
    requestsActionCreators,
    communityActionCreators,
    membersActionCreators,
    CommunityEditModal,
  } = props;
  const { initialValues, isCommunityPanelOpen } = community || {};
  const { communityId, isMember } = initialValues || {};
  const [_isMember, _setIsMember] = React.useState<boolean>(isMember);
  const [_communityId, _setCommunityId] = React.useState<number>(communityId);
  console.log('CommunityPanelComponent', community);
  console.log('CommunityPanelComponent isCommunityPanelOpen', isCommunityPanelOpen);

  React.useEffect(() => {
    /**
     * Dismiss panel when membership has changed if user is in same community
     */
    if ( communityId === _communityId && isMember !== _isMember ) {
      _setCommunityId(communityId);
      _setIsMember(isMember);
      // onPanelDismiss();
    }
  }, [communityId, isMember])

  const _onPanelDismiss = () => {
    communityActionCreators.closeCommunityPanel();
    onPanelDismiss?.();
    console.log('_onPanelDismiss 1');
  };

  const getTags = (community) => {
    const tags = community.tags;

    return (
      <div className='tags'>
        {tags.map((tag, idx) => {
          return <Tag tag={tag} key={idx} />;
        })}
      </div>
    );
  };

  const onRenderBody = () => {
    return (
      <React.Fragment>
        {initialValues && (
          <div className='panelBody'>
            <h2>{initialValues.displayName}</h2>
            <table className='communityInfo'>
              <tbody>
                <tr>
                  <td>
                    <Icon iconName='People' />
                  </td>
                  <td>
                    <TooltipHost
                      content={`This community has ${initialValues.totalMembers} members`}
                      directionalHint={DirectionalHint.rightTopEdge}
                    >
                      {initialValues.totalMembers} Members
                    </TooltipHost>
                  </td>
                </tr>
                <tr>
                  <td>
                    {initialValues.communityType !== 'Hidden' ? (
                      <Icon
                        iconName={
                          initialValues.communityType === 'Open'
                            ? 'Unlock'
                            : 'Lock'
                        }
                      />
                    ) : (
                      <Icon iconName='Hide' />
                    )}
                  </td>
                  <td>
                    <TooltipHost
                      content={`This community is ${initialValues.communityType}`}
                      directionalHint={DirectionalHint.rightTopEdge}
                    >
                      {initialValues.communityType}
                    </TooltipHost>
                  </td>
                </tr>
                {initialValues.tags.length > 0 && (
                  <tr>
                    <td>
                      <Icon iconName='Tag' />
                    </td>
                    <td>{getTags(initialValues)}</td>
                  </tr>
                )}
                {initialValues.isOwner && initialValues.pendingRequests > 0 && (
                  <tr>
                    <td>
                      <div className='counter'>
                        {initialValues.pendingRequests.toString()}
                      </div>
                    </td>
                    <td>Request count</td>
                  </tr>
                )}
              </tbody>
            </table>
            {initialValues.description && (
              <div>
                <h3>About</h3>
                <p>{initialValues.description}</p>
                <hr />
              </div>
            )}

            {allMembers?.length > 0 && (
              <>
                <h3>Owners</h3>
                <Owners
                  brandName={brandName}
                  community={initialValues}
                  items={allMembers}
                  profile={profile}
                  membersActionCreators={membersActionCreators}
                />
                <hr />
              </>
            )}

            {initialValues.isCreated && <h3>Community tools</h3>}
            <CommunityTools
              CommunityEditModal={CommunityEditModal}

              community={initialValues}
              profile={profile}
              constants={constants}
              showManagementTools={true}

              inviteMembersActionCreators={inviteMembersActionCreators}
              requestsActionCreators={requestsActionCreators}
              communityActionCreators={communityActionCreators}
              membersActionCreators={membersActionCreators}
            />
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <Panel
      className='govTeams-communityPanel'
      isOpen={isCommunityPanelOpen}
      hasCloseButton={true}
      isBlocking={true}
      isLightDismiss={true}
      type={PanelType.custom}
      customWidth={'400px'}
      onDismiss={_onPanelDismiss}
      onRenderBody={onRenderBody}
    />
  );
}

export default CommunityPanelComponent;
